<script setup lang="ts">
import { computed } from 'vue'
import BaseButton from '@/components/Base/BaseButton.vue'

import type { ContestColor, GameContest } from '@/types'

const emit = defineEmits(['scroll-to-form'])
const props = defineProps<{
  contestGame: GameContest
  contestColor: ContestColor
}>()

const hasCoverImage = computed(() => props.contestGame?.coverImageUrl !== null)

const scrollToForm = () => {
  emit('scroll-to-form')
}
</script>

<template>
  <div
    class="relative flex flex-col items-center justify-center bg-cover bg-center px-6 py-28 text-center md:p-24 lg:py-36"
    :style="{
      backgroundImage: `url(${contestGame.coverImageUrl})`,
    }"
  >
    <div
      v-if="hasCoverImage"
      class="absolute left-0 right-0 top-0 h-full w-full bg-black opacity-60"
    />

    <div class="z-10 w-full md:max-w-5xl">
      <h1
        :style="{ color: `${contestColor.textColor}` }"
        class="text-3xl font-bold text-white md:text-5xl"
      >
        {{ contestGame.title }}
      </h1>

      <p :style="{ color: `${contestColor.textColor}` }" class="mt-3 text-2xl text-white">
        {{ contestGame.subtitle }}
      </p>

      <base-button is-active class="mt-10" @click="scrollToForm">
        <div class="flex items-center justify-center">
          {{ contestGame.callToActionText }}
        </div>
      </base-button>
    </div>
  </div>
</template>
